'use client'
import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { useDispatch } from 'react-redux'
import { setHeading } from '@/lib/Features/ThemeSlice/themeSlice'
import { useQuery } from '@tanstack/react-query'
import CustomFetch from '@/Utils/APIRequest/AxiosInstance'
import usePost from '@/Utils/Hooks/usePost'
import Loader from '@/Layout/Loader'
import { CustomToast } from '@/Utils/CustomToast'
import { TermsConditionsAPI } from '@/Utils/APIRequest/Endpoints'
import GradientButton from '@/Component/Common/Forms/GradientButton'
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG'

const CustomCKEditor = dynamic(() => import('@/Component/Common/CustomCKEditor'), { ssr: false })

const AdminTermsConditions = () => {
    const dispatch = useDispatch()
    const [termsValue, setTermsValue] = useState(null)

    const { data, isPending, refetch } = useQuery({ queryKey: [TermsConditionsAPI], queryFn: () => CustomFetch({ url: TermsConditionsAPI }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data });

    const { isPending: CreateLoader, mutate } = usePost(TermsConditionsAPI, null, (response) => {
        CustomToast("success", 'Terms & conditions is updated successfully')
        refetch()
    }, 'Put');

    useEffect(() => {
        dispatch(setHeading("Content Management"))
        setTermsValue(data?.description)
    }, [data])

    const handleSubmit = () => {
        if (termsValue) {
            let obj: any = {
                title: data?.title ?? "",
                description: termsValue
            }
            mutate(obj)
        }
    }
    if (isPending) return <Loader />
    return (
        <>
            {/* <h2 className='text-2xl font-semibold mb-4'>{'Terms & Conditions'}</h2> */}
            <CustomCKEditor values={termsValue} customSetterFun={setTermsValue} placeholder='Enter terms & conditions' />
            <GradientButton customClass="mt-4 flex items-center justify-center" buttonType='submit' onClick={handleSubmit} disabled={CreateLoader}>
                {'Save'} {CreateLoader && <LoaderSVG customClass='ml-[10px]' />}
            </GradientButton>
        </>
    )
}

export default AdminTermsConditions